import { Box } from "@material-ui/core";

function BottomDrawerButtons(props: { component: JSX.Element }) {
	return (
		<Box paddingX={2} width="100%" display="flex" justifyContent="space-between">
			{props.component}
		</Box>
	);
}

export default BottomDrawerButtons;
